import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {deleteForumTopic, fetchForumTopic, resetForumTopic} from "../../../creators/forums.topic";

import Topic from './components/Topic';
import {PageLoader} from '../../components/Loader';
//import history from "../../../libs/history";
import createLink from "../../../libs/createLink";
import Advertising from "../../components/Advertising/Advertising";
import {topicViews} from "../../../creators/views";
import _ from "lodash";
import ErrorNotFound from "../ErrorNotFound";
import TagModerationQualificationWarning
    from "../../components/TagModerationQualificationWarning/TagModerationQualificationWarning";
import {Can} from "../../../ability-context";


class ForumsTopic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleted : false
        }

        this.deleteTopic = this.deleteTopic.bind(this);
        this.props.resetForumTopic();
        this.props.fetchForumTopic(this.props.match.params.topicId);

    }

    componentWillUnmount() {
        this.props.resetForumTopic();
    }


    componentDidUpdate(nextProps) {

       /* if(this.props.forumTopicInitialized && this.props.forumTopic?.slug && this.props.match?.params?.topicSlug && (this.props.forumTopic.slug !== this.props.match?.params.topicSlug)){
            history.push(createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent}, category : {slug : this.props.forumTopic.forum.slug, _id : this.props.forumTopic.forum._id}, topic : {_id : this.props.forumTopic._id, slug : this.props.forumTopic.slug}}));
        }*/

        if(this.props.forumTopicInitialized !== nextProps.forumTopicInitialized && this.props.forumTopicInitialized){
            this.props.topicViews(this.props.match.params.topicId);
        }

        if (nextProps.match.params.topicId !== this.props.match.params.topicId) {
            // this.props.getForumsArticle(nextProps.match.params.id || 0,{breadcrumbsShow : true, isFirstPost : true});
            this.props.resetForumTopic();
            this.props.fetchForumTopic(this.props.match.params.topicId);
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.forumTopicLoading !== nextProps.forumTopicLoading){
            return true;
        }
        if(this.props.forumTopicError.statusCode !== nextProps.forumTopicError.statusCode && nextProps.forumTopicError.statusCode === 404){
            return true;
        }

        if(this.props.forumTopic.isFollow !== nextProps.forumTopic.isFollow){
            return true;
        }

        return this.props.forumTopicInitialized !== nextProps.forumTopicInitialized;
    }

    deleteTopic(forumId, topicId){
        this.setState({isDeleted : true});

        this.props.deleteForumTopic(forumId, topicId);
        this.props.resetForumTopic();
        let url = this.props.match.url;
        let slug = this.props.match.params.slug;
        let regex = new RegExp(`(.*)${slug}`, 'g');
        let found = url.match(regex);
        if(found && found[0]){
            window.location.href = found[0];
            //this.props.history.push(found[0]);
        }
        else{
            this.props.history.push(createLink("forum"));
        }


    }

    render() {
        if(_.get(this.props.forumTopicError,"statusCode") === 404 || this.state.isDeleted){
            return <ErrorNotFound />
        }
        return !this.props.forumTopicInitialized ? <PageLoader/> : (
            <div className="forums-topic">
                <Can action={"qualification"} subject="TagModeration">
                    <TagModerationQualificationWarning />
                </Can>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className={"forum-card"}>
                        <div className={"card"}>
                            {this.props.forumTopicError.message && (
                                <div className="warning">{this.props.forumTopicError.message}</div>
                            )}
                            {/*{!this.props.articleLoading && this.props.articleError && (this.props.articleError.status === "400" || this.props.articleError.status === "500") && (<div className="warning">Impossible de charger le post</div> )}*/}
                            {/*{!this.props.articleLoading && this.props.articleError && (this.props.articleError.status === "401") && (<div className="warning">vous n'êtes pas autorisé à afficher cette page</div> ) }*/}

                            {/*{this.props.forumTopicLoading ? <PageLoader/> : (*/}
                            {/*    <Topic*/}
                            {/*        {...this.props.forumTopic}*/}
                            {/*        page={this.props.match.params.page || 1}*/}
                            {/*        history={this.props.history}*/}
                            {/*        match={this.props.match}*/}
                            {/*        currentUser={this.props.currentUser}*/}
                            {/*        reloadArticle={this.reloadArticle}*/}
                            {/*    />*/}
                            {/*)}*/}

                            <Topic
                                redirectToLastPage={_.get(this.props, "location.state.redirectToLastPage") ? true : false}
                                {...this.props.forumTopic}
                                isFollow={this.props.forumTopic.isFollow || false}
                                page={this.props.match.params.page || 1}
                                history={this.props.history}
                                match={this.props.match}
                                forumTopicLoading={this.props.forumTopicLoading}
                                deleteTopic={this.deleteTopic}
                            />

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        forumTopic: state.forumTopic.data,
        forumTopicLoading: state.forumTopic.loading,
        forumTopicInitialized: state.forumTopic.initialized,
        forumTopicError: state.forumTopic.error,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumTopic,
    resetForumTopic,
    deleteForumTopic,
    topicViews
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ForumsTopic);
